import { gql, TypedDocumentNode } from '@apollo/client'
import { IAgencyGroup, IAgencyGroupJobConfig } from 'pages/agency-group-management/interface'

type CreateNewAgencyGroupMutation = {
  createNewAgencyGroup: {
    agencyGroupId: number
    agencyGroupName: string
  }
}

type CreateNewAgencyGroupVariables = {
  data: {
    agencyGroupName: string
  }
}

export const CREATE_NEW_AGENCY_GROUP: TypedDocumentNode<
  CreateNewAgencyGroupMutation,
  CreateNewAgencyGroupVariables
> = gql`
  mutation CreateNewAgencyGroup($data: CreateAgencyGroupInput!) {
    createNewAgencyGroup(data: $data) {
      agencyGroupId
      agencyGroupName
    }
  }
`

type GetAllAgencyGroupQuery = {
  getAllAgencyGroup: IAgencyGroup[]
}

type GetAllAgencyGroupVariable = {
  skip: number
  take: number
}

export const GET_ALL_AGENCY_GROUP: TypedDocumentNode<
  GetAllAgencyGroupQuery,
  GetAllAgencyGroupVariable
> = gql`
  query GetAllAgencyGroup($skip: Int, $take: Int) {
    getAllAgencyGroup(skip: $skip, take: $take) {
      agencyGroupId
      agencyGroupName
    }
  }
`

type GetDetailAgencyGroupByIdQuery = {
  getDetailAgencyGroupById: IAgencyGroupJobConfig[]
}

type GetDetailAgencyGroupByIdVariables = {
  agencyGroupId: number
  customJobType: string
}

export const GET_DETAIL_AGENCY_GROUP_BY_ID: TypedDocumentNode<
  GetDetailAgencyGroupByIdQuery,
  GetDetailAgencyGroupByIdVariables
> = gql`
  query GetDetailAgencyGroupById($agencyGroupId: Int!, $customJobType: String!) {
    getDetailAgencyGroupById(agencyGroupId: $agencyGroupId, customJobType: $customJobType) {
      agencyGroupJobConfigId
      subEmailManagementConfigId
      agencyGroupId
      customJobType
      customEmailType
      emailTemplateURL
      htmlTemplateString
      forwardWebhook
      forwardEmail
      forwardFormatTemplate
      subEmailManagementConfig {
        sendingEmailSubject
        emailManagementConfig {
          emailManagementConfigId
          cancelSubject
          startSubject
        }
        tDayConfig {
          configId
          key
          value
        }
      }
    }
  }
`

type AddOrEditAgencyGroupJobConfigMutation = {
  addOrEditAgencyGroupJobConfig: boolean
}

export enum AgencyGroupJobTypeEnum {
  CUSTOM_EMAIL = 'CUSTOM_EMAIL',
  FORWARD_WEBHOOK = 'FORWARD_WEBHOOK',
  FORWARD_EMAIL = 'FORWARD_EMAIL',
}

export interface IAgencyGroupJobConfigInput {
  emailTemplateURL: string | null
  htmlTemplateString: string | null
  subEmailManagementConfigId: string | null
  customEmailType: string | null
  customJobType: AgencyGroupJobTypeEnum
  forwardWebhook: Record<string, any> | null
  forwardEmail: Record<string, any> | null
  forwardFormatTemplate: string | null
}

type AddOrEditAgencyGroupJobConfigVariable = {
  data: {
    agencyGroupId: number
    customJobType: string
    customConfigs: IAgencyGroupJobConfigInput[]
  }
}

export const ADD_OR_EDIT_AGENCY_GROUP_JOB_CONFIG: TypedDocumentNode<
  AddOrEditAgencyGroupJobConfigMutation,
  AddOrEditAgencyGroupJobConfigVariable
> = gql`
  mutation AddOrEditAgencyGroupJobConfig($data: AddOrEditAgencyGroupJobConfigInput!) {
    addOrEditAgencyGroupJobConfig(data: $data)
  }
`
type DeleteAgencyGroupMutation = {
  deleteAgencyGroup: boolean
}

type DeleteAgencyGroupVariable = {
  agencyGroupId: number
}

export const DELETE_AGENCY_GROUP: TypedDocumentNode<
  DeleteAgencyGroupMutation,
  DeleteAgencyGroupVariable
> = gql`
  mutation DeleteAgencyGroup($agencyGroupId: Int!) {
    deleteAgencyGroup(agencyGroupId: $agencyGroupId)
  }
`

type DeleteAgencyFromAgencyGroupMutation = {
  deleteSingleAgencyFromAgencyGroup: boolean
}

type DeleteAgencyFromAgencyGroupVariable = {
  data: {
    agencyGroupId: number
    agencyId: string
  }
}

export const DELETE_AGENCY_FROM_AGENCY_GROUP: TypedDocumentNode<
  DeleteAgencyFromAgencyGroupMutation,
  DeleteAgencyFromAgencyGroupVariable
> = gql`
  mutation ($data: DeleteAgencyFromAgencyGroupInput!) {
    deleteSingleAgencyFromAgencyGroup(data: $data)
  }
`

type DeleteConfigAgencyGroupByJobTypeMutation = {
  deleteConfigAgencyGroupByJobType: boolean
}

type DeleteConfigAgencyGroupByJobTypeVariable = {
  agencyGroupId: number
  customJobType: AgencyGroupJobTypeEnum
}

export const DELETE_CONFIG_AGENCY_GROUP_BY_JOB_TYPE: TypedDocumentNode<
  DeleteConfigAgencyGroupByJobTypeMutation,
  DeleteConfigAgencyGroupByJobTypeVariable
> = gql`
  mutation DeleteConfigAgencyGroupByJobType($agencyGroupId: Int!, $customJobType: String!) {
    deleteConfigAgencyGroupByJobType(agencyGroupId: $agencyGroupId, customJobType: $customJobType)
  }
`
